<template>
  <div style="width: 100%; height: 100%;">
    <div style="height: 100%; width: 100%;" v-if="type !== 'NPS'">
      <div
        class="lgrm-emoji-display lgrm-comments-emoji-wrapper"
        :style="{ background: ratingColors['rated' + answer], 'margin-left': 0 }"
      >
        <Emoji
          :rating="answer"
          :label="ratingLabels['rated' + answer]"
          :color="ratingColors['rated' + answer]"
          border-color="#fff"
          :organColor="ratingColors['rated' + answer]"
          :selected="false"
          :bgColor="'#fff'"
          :size="emojiSize"
          :bodyStyle="{ width: 'auto',
            'height': 'auto' }"
          :labelStyle="{
            'font-weight': 500,
            'font-size': '14px',
            'color': '#fff',
            'line-height': '1.2',
            'margin-top': '0px',
            'margin-left': 'auto',
            'display': 'block'
          }"
          readonly
          :embed="true"
          
        ></Emoji>
      </div>
    </div>
    <div v-if="type === 'NPS'" style="width: 100%; height: 100%;">
      <div
        class="lgrm-emoji-display comments-emoji-wrapper"
        :style="{ background: ratingColors.rated1, 'margin-left': 0 }"
        v-if="answer >= 0 && answer <= 6"
      >
        <div class="lgrm-nps-score" :style="{ color: ratingColors.rated1 }">
          {{ answer }}
        </div>
        <div class="lgrm-emoji-label">
          {{ ratingLabels.rated1 }}
          <!--<span class="rating-range">(0-6)</span>-->
        </div>
      </div>

      <div
        class="lgrm-emoji-display comments-emoji-wrapper"
        :style="{ background: ratingColors.rated3, 'margin-left': 0 }"
        v-if="answer === 7 || answer === 8"
      >
        <div
          class="lgrm-nps-score"
          :style="{
            color: ratingColors.rated3,
            width: size + 'px',
            height: size + 'px',
            'line-height': size + 'px'
          }"
        >
          {{ answer }}
        </div>
        <div class="lgrm-emoji-label">
          {{ ratingLabels.rated2 }}
          <!--<span class="rating-range">(7-8)</span>-->
        </div>
      </div>

      <div
        class="lgrm-emoji-display comments-emoji-wrapper"
        v-if="answer === 9 || answer === 10"
        :style="{ 'margin-left': 0, background: ratingColors.rated5 }"
      >
        <div
          class="lgrm-nps-score"
          :style="{
            color: ratingColors.rated5,
            width: size + 'px',
            height: size + 'px',
            'line-height': size + 'px'
          }"
        >
          {{ answer }}
        </div>
        <div class="lgrm-emoji-label">
          {{ ratingLabels.rated3 }}
          <!--<span class="rating-range">(9-10)</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Emoji from '../../../widgets/feedback/src/components/question_types/Emoji.vue'

export default {
  name: 'ResponseRatingAnswerDisplay',
  components: { Emoji },
  props: {
    ratingColors: {
      type: Object
    },
    answer: Number,
    ratingLabels: {
      type: Object
    },
    type: String,
    size: {
      type: Number,
      default: 50
    },
    emojiSize: {
      type: Number,
      default: 50
    }
  }
}
</script>

<style lang="stylus">
.lgrm-emoji-display {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding 20px
    text-align center
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .lgrm-emoji-label {
        color: #fff
        font-weight 500
        margin-top 10px
    }

    .lgrm-nps-score {
        font-size: 32px;
        height: 50px;
        background: #fff;
        width: 50px;
        text-align: center;
        border-radius: 50%;
        box-sizing: border-box;
        line-height: 53px;
    }
}
</style>
